/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material';
import Popover from '@mui/material/Popover';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import * as React from 'react';


const styles = (theme: Theme) => ({
    showColumnButton: {
        margin: '20px 20px 20px 0'
    },
    title: {
        margin: '20px',
        fontWeight: 'bold' as const
    },
    formItem: {
        marginLeft: '5px'
    },
    formControl: {
        maxWidth: '250px',
        maxHeight: '250px'
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
});
interface Props {
    columns: Array<Object>,
    onColumnUpdate: Function,
    classes?: any,
}
class TableViewCol extends React.Component<Props, {}>{
    state = {
        open: false
    };
    handleColChange = (index: number) => {
        this.props.onColumnUpdate(index);
    };
    handleClick = () => {
        this.setState({ open: true });
    };
    handleClose = () => {
        this.setState({ open: false });
    };
    anchorEl: any;

    render() {
        const { columns, classes } = this.props;
        return (
            <div className={classes.root}>
                <Button id="showColumnButton" onClick={this.handleClick}
                    ref={node => {
                        this.anchorEl = node;
                    }}
                    className={classes.showColumnButton}
                >
                    <ViewColumnIcon />
                </Button>
                <Popover
                    open={this.state.open}
                    onClose={this.handleClose}
                    anchorEl={this.anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <FormControl className={classes.formControl}>
                        <Typography className={classes.title}>
                            Show Columns
                        </Typography>
                        <FormGroup id="showColumnGroup">
                            {columns.map((column: any, index: number) => {
                                return (
                                    <FormControlLabel
                                        className={classes.formItem}
                                        key={index}
                                        id={column.title}
                                        control={
                                            <Checkbox
                                                onChange={this.handleColChange.bind(null, index)}
                                                checked={column.display === true}
                                                value={column.name}
                                            />
                                        }
                                        label={column.title}
                                    />
                                );
                            })}
                        </FormGroup>
                    </FormControl>
                </Popover>
            </div>
        );
    }
}
export default withStyles(styles)(TableViewCol);
